import React from 'react';
import { Color } from 'csstype';

class ABPlayersProgress extends React.Component {
    activeSource: any;
    canvas: any;
    context: CanvasRenderingContext2D;
    ratio: number;
    posX: number;
    posY: number;
    progressInterval: number;
    progressValue = 0;
    inProgress: boolean;
    raf: any;
    backgroundColor: Color = '#ffffff';

    constructor(activeSource: any) {
        super(activeSource);
        this.activeSource = activeSource;
        this.setProgressBar();
    }

    public startProgress() {
        this.inProgress = true;
        cancelAnimationFrame(this.raf);
        this.update();
    }

    public updateSource(activeSource: any) {
        this.activeSource = activeSource;
    }

    public clearProgress() {
        this.inProgress = false;
    }

    public destroy() {
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        cancelAnimationFrame(this.raf);
    }

    setProgressBar() {
        this.canvas = document.getElementById('Progress-bar');
        this.context = this.canvas.getContext('2d');
        this.ratio = window.devicePixelRatio || 1;
        if (1 !== this.ratio) {
            this.canvas.style.width = `${this.canvas.width}px`;
            this.canvas.style.height = `${this.canvas.height}px`;
            this.canvas.width *= 2;
            this.canvas.height *= 2;
            this.context.scale(2, 2);

            this.posX = this.canvas.width / 4;
            this.posY = this.canvas.height / 4;
        } else {
            this.posX = this.canvas.width / 2;
            this.posY = this.canvas.height / 2;
        }
    }

    update() {
        if (this.inProgress) {
            this.progressValue = (this.activeSource.original.seek() * 360) / this.activeSource.original.duration();
        } else {
            this.progressValue < 2 ? (this.progressValue = 0) : (this.progressValue = this.progressValue - 2);
        }

        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);

        this.context.beginPath();
        this.context.strokeStyle = '#32cbcb';
        this.context.lineWidth = 5;
        this.context.arc(
            this.posX,
            this.posY,
            30,
            (Math.PI / 180) * 270,
            (Math.PI / 180) * (270 + Math.abs(this.progressValue)),
        );
        this.context.stroke();

        this.raf = requestAnimationFrame(() => this.update());
    }

    render() {
        return null;
    }
}

export { ABPlayersProgress };
